module.exports = __webpack_public_path__ + "img/loading-01.ee2e74a7.svg";